require("slick-carousel/slick/slick");

$(".full-slider").slick({
    dots: false,
    infinite: true,
    prevArrow: ".demonstrator-slides__previous",
    nextArrow: ".demonstrator-slides__next",
    slidesToShow: 4,
    slidesToScroll: 4,
    responsive: [
        {
            breakpoint: 1000,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 640,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ],
});
